import React from 'react'
import Column from '~/Common-Objects/Grids/Column/Column';
import Icons from '~/Common-Objects/UI/Icons/index';
import Paper from '~/Common-Objects/UI/Paper/Paper';
import Row from '~/Common-Objects/Grids/Row/Row';
import { connect } from 'react-redux';
import axios from 'axios';
import DbConn from '~/Classes/siteVars.js'
import axios2 from 'axios'
@connect((store) => {
    return { siteMaster: store.siteMaster, browser: store.browser, user: store.user, accountMaster: store.accountMaster }
})

export default class LatestNews extends React.Component {
    constructor(props) {
        super(props)

    }

    render() {
        return <Row>
            <Column xs={12} margin={0}>
                <Paper style={{
                    display: "flex",
                    padding: "16px 20px"
                }}
                >
                    <Icons icon="megaphone" circle={true} style={{ width: "20px", height: "20px" }} className="mar-r10" />
                    <div style={{ fontWeight: "600" }}>We’ve recently updated the layout within Transpond to offer you a better experience.</div>
                </Paper >
            </Column>
        </Row >
    };
};
